import React, { Component } from "react";
import { connect } from "react-redux";

import ComponentSelector from "../utils/components/ComponentSelector";
import MyChargers from "./MyChargers";
import OtherChargers from "./OtherChargers";
import Groups from "./Groups";
import Tariffs from "./Tariffs";
import PurchaseTariffs from "./PurchaseTariffs";
import EnergyManagement from "./EnergyManagement";

class Chargers extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.tabListGenerator = this.tabListGenerator.bind(this);
  }

  tabListGenerator() {
    let tabList = [
      { title: "label_myChargers", component: <MyChargers /> },
      { title: "label_otherChargers", component: <OtherChargers /> },
      { title: "label_groups", component: <Groups /> },
      { title: "label_tariffs", component: <Tariffs /> },
      { title: "label_costTariffs", component: <PurchaseTariffs /> },
    ];

    // Only users with energyManagementEnable can view the energy management tab
    if (this.props.userPackage && this.props.userPackage.energyManagementEnabled)
    {
      tabList = [
        ...tabList,
        { title: "label_energyManagement", component: <EnergyManagement /> },
      ];
    }
    return tabList;
  }

  render() {
    return (
      <div id="chargers" className="evio-container sidebar-fix main-component">
        <ComponentSelector
          tabs={this.tabListGenerator()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userPackage: state.account.accountData.userPackage,
  isAdmin: state.account.isAdmin,
});

export default connect(mapStateToProps)(Chargers);

